import React from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import StatusForm from "./StatusForm";
import DomainInfoUpdateBox from "../../Box/DomainInfoCustomableBox";
import Spinner from "../../../../commons/components/FeedBack/Spinner/Spinner";


class DomainUpdateStatus extends React.Component {

    render() {
        const {infoDomainData, updateDomainHostData, intl} = this.props;
        const {formatMessage} = intl;
        return (
            <div>
                <DomainInfoUpdateBox
                    title={formatMessage({id: "domain.update.status.form.title"})}
                    hasRegistrarPermission={this.props.hasRegistrarPermission}
                    infoData={this.props.infoDomainData.data}
                    error={this.props.updateDomainHostData.error}
                    loading={this.props.updateDomainHostData.loading}
                    message={this.props.updateDomainHostData.message}
                    reset={this.props.reset}
                >
                    <StatusForm
                        onCancel={this.props.onCancel}
                        onSubmit={this.props.onUpdateStatus}
                        data={infoDomainData.data}
                    />
                    <Spinner loading={updateDomainHostData.loading}/>
                </DomainInfoUpdateBox>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        infoDomainData: state.domain.infoReducer,
        updateDomainHostData: state.domain.updateReducer,
    };
}

export default connect(mapStateToProps)(injectIntl(DomainUpdateStatus));


DomainUpdateStatus.propTypes = {
    hasRegistrarPermission: PropTypes.bool,
    onUpdateStatus: PropTypes.func,
    onCancel: PropTypes.func,
    reset: PropTypes.func,

};
